import React from "react";

import Root from "./routes";

function App() {
  return (
    <div className="App">
      <Root />
    </div>
  );
}

export default App;
